import React from "react";
import heroLeftImg from "../images/comp/hero-leftimg.webp";
import qualityIcon from "../images/quality.svg";
import customizedIcon from "../images/customized.svg";


const HomeHeroSection = () => {
  return (
    <section className="hero-section d-flex align-items-center">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 hero-content">
            <span className="hero-subtitle">
              Digital Innovation &amp; Transformation Solutions
            </span>
            <h1 className="hero-title">
              Your Partner to Grow
              <br />
              Your Business Digitally
              <br />
              with{" "}
            </h1>
            <h1 className="hero-title">
              <span className="highlight" id="hero-animated-text"></span>
            </h1>
            <a href="#services" className="btn btn-orange mt-2">
              Explore Services
            </a>
            <div className="hero-features d-flex mt-4">
              <div className="feature-item me-4">
                <img
                  src={qualityIcon}
                  alt="Quality Services"
                  className="feature-icon"
                />
                <span>Quality Services</span>
              </div>
              <div className="feature-item">
                <img
                  src={customizedIcon}
                  alt="Customized Solutions"
                  className="feature-icon"
                />
                <span>Customized Solutions</span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 hero-image text-center mt-5 mt-lg-0">
            <img
              src={heroLeftImg}
              alt="Hero Main"
              className="img-fluid main-hero-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHeroSection;
